<template>
  <progress-ring
    v-if="loyalty.finalThreshold"
    :show-progress-ring-indicator="loyalty.profileShowProgressIndicatorEnabled"
    :label="loyalty.currency.pluralShortNameUpperCase"
    :checkpoints="checkpoints"
    :progress="loyalty.currentBalance"
    :steps="loyalty.finalThreshold.cost"
  />
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'LoyaltyProgressRing',

    computed: {
      ...mapGetters('offers', ['loyalty']),

      checkpoints() {
        if (!this.loyalty.isMultiTiered) {
          return [];
        }

        const checkpoints = this.loyalty.allThresholds.map(threshold => ({
          content: `${threshold.rewardOffer.title} <span class="tag tag--inline">${threshold.cost} ${this.loyalty.currency.pluralShortNameUpperCase}</span>`,
          value: threshold.cost
        }));

        return checkpoints;
      }
    }
  };
</script>
